/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ entity: NonNullable<unknown> }} General_Assignable_ItemsInputs */

const en_general_assignable_items = /** @type {(inputs: General_Assignable_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Assignable ${i?.entity}`)
};

const de_general_assignable_items = /** @type {(inputs: General_Assignable_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuweisbare ${i?.entity}`)
};

/**
* | output |
* | --- |
* | "Assignable {entity}" |
*
* @param {General_Assignable_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_assignable_items = /** @type {((inputs: General_Assignable_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Assignable_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_assignable_items(inputs)
	return de_general_assignable_items(inputs)
});